import GokuDataGrid from '@/components/GokuDataGrid'
import { getResellerCandidates } from '@/modules/Reseller/services'
import { ResellerCandidateContact } from '@/modules/Reseller/types'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { resellerCandidateColumns } from './columns'

const Candidates = () => {
    const navigate = useNavigate()
    const { t } = useTranslation('reseller')

    const columns = useMemo(
        () => resellerCandidateColumns(t, navigate),
        [navigate, t]
    )

    return (
        <div className="my-2">
            <GokuDataGrid<ResellerCandidateContact, ResellerCandidateContact>
                apiCall={getResellerCandidates}
                columns={columns}
                reactQueryKey={`${QUERY_KEYS.RESELLERS}-candidates`}
                dataGridProps={{
                    getRowId: (row) => row?.customer_contact_id,
                }}
                searchPlaceholder={t('search_candidates')}
            />
        </div>
    )
}

export default Candidates
